import React from 'react';
import { useTestId } from '../../hooks/useTestId/useTestId';
import { ITextProps, Span, useTextCss } from '../Texts/Texts';
import { EORA_SPACES_STANDARD, IGutterProps, useGutterAsMarginCss } from '../../fundamentals/spaces/space';
import styled, { css } from 'styled-components';
import { STATUS_COLOURS } from '../../fundamentals/colours/variants';
import { FONT_WEIGHTS } from '../../fundamentals/typography/typography';
import { PX_TO_REM } from '../../fundamentals/sizes/sizes';
import { IInvalidProps } from '../../fundamentals/actions';
import { IColoursCollection } from '../../fundamentals/colours/colourInterfaces';
import { BaseLabel } from '../../common/BaseElements';

export const labelColours = ({ text }: IColoursCollection) => ({
  labelColours: {
    [STATUS_COLOURS.ERROR]: {
      text: text.error
    }
  }
});

export interface ILabelProps extends IGutterProps, ITextProps, React.LabelHTMLAttributes<HTMLLabelElement>, IInvalidProps {
  /**
   * @deprecated
   */
  light?: boolean; // fontWeight has 2 options only, default = 500, light = 400
  required?: boolean;
}

const LabelContainer = styled(BaseLabel)<ILabelProps>`
  ${useGutterAsMarginCss()};
  ${useTextCss};

  font-weight: ${({ theme }) => theme.fonts.fontWeights[FONT_WEIGHTS.MEDIUM]};
  display: flex;

  ${({ invalid }) =>
    invalid &&
    css`
      color: ${({ theme }) => theme.labelColours[STATUS_COLOURS.ERROR].text};
    `}

  gap: ${({ theme }) => theme.eoraSpaces[EORA_SPACES_STANDARD.XSMALL]};
`;

const MandatoryIndicator = styled(Span)`
  color: ${({ theme }) => theme.labelColours[STATUS_COLOURS.ERROR].text};
  padding-right: ${PX_TO_REM[2]};
`;

export const Label: React.FC<React.PropsWithChildren<ILabelProps>> = ({ required, children, ...rest }) => {
  const { generateTestId } = useTestId(rest, 'Label');

  return (
    <LabelContainer textStyle='MEDIUM' lineHeight={24} {...generateTestId()} {...rest}>
      {!!required && <MandatoryIndicator>*</MandatoryIndicator>}
      {children}
    </LabelContainer>
  );
};
